<template>
  <div>
    <hi-dialog
      title="Edit Phone Numbers"
      ref="dialog"
      v-model="isOpen"
      :submit-disabled="!valid"
      @submit="submit"
      :error="error"
    >
      <v-form v-model="valid">
        <v-text-field
          v-model="mobile"
          :rules="mobileRules"
          label="Mobile"
          ref="mobileInput"
        >
        </v-text-field>
      </v-form>
      <v-form v-model="valid">
        <v-text-field
          v-model="phone"
          :rules="phoneRules"
          label="Phone"
          ref="phoneInput"
        >
        </v-text-field>
      </v-form>
    </hi-dialog>
  </div>
</template>

<script>
import HiDialog from "@/components/HiDialog";
// import HiSimpleInput from "@/components/HiSimpleInput";
import Validator from "@/hive/Validator";
import { DocHelper } from "@/db";
export default {
  name: "DiEmailEditor",
  components: { HiDialog },
  props: {
    collectionPath: {
      type: String,
      required: true
    },
    docPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      // emailValidator: Validator.email,
      mobile: null,
      mobileRules: [v => Validator.mobile(v) || "Mobile must be valid"],
      phone: null,
      phoneRules: [
        v => Validator.phoneNumber(v) || "Phone Number must be valid"
      ],
      valid: false,
      error: null
    };
  },
  methods: {
    open(data) {
      this.isOpen = true;
      this.mobile = data.mobile;
      this.phone = data.phone;
      setTimeout(() => this.$refs.mobileInput.focus(), 100);
    },
    async submit() {
      console.log(this.docPath);
      console.log(this.mobile);
      console.log(this.phone);
      try {
        const helper = new DocHelper(this.collectionPath, this.docPath);
        helper.noToast = true;
        await helper.update({
          mobile: this.mobile,
          phone: this.phone
        });
        this.isOpen = false;
      } catch (e) {
        this.error = e.message;
      }
    }
  }
};
</script>

<style scoped></style>
